import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles/index';

const styles = theme => ({
  emphasis: {
    color: theme.palette.primary.main,
    lineHeight: 1,
    letterSpacing: -1.32,
    fontFamily: "BornReady-Slanted"
  }
});

class Emphasis extends Component {
  render() {
    const {classes, children, className, ...other} = this.props;
    return <em className={className ? className : classes.emphasis} {...other}>{children}</em>;
  }
}


Emphasis.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles, {withTheme: true})(Emphasis);
